import {BaseEvent} from "./BaseEvent";

export class ChangeDashboardEditModeEvent extends BaseEvent {
  public static NAME = 'ChangeDashboardEditModeEvent';
  public editMode: boolean;

  constructor(editMode: boolean) {
    super(ChangeDashboardEditModeEvent.NAME);
    this.editMode = editMode;
  }
}
